import { loadRuntimeEnv } from './runtime/runtime-env';

loadRuntimeEnv().then(() => import('./Bootstrap'));
export {};
